import { HTTP } from 'providers'
export class LanguageService extends HTTP {
  private endpoint = '/language'

  public async getAllLang() {
    return this.get({ endpoint: this.endpoint })
  }
}
